"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("@enable3d/three-wrapper/dist/index");
class DefaultMaterial {
    constructor() {
        this._defaultMaterial = new index_1.MeshLambertMaterial({ color: 0xcccccc });
    }
    get() {
        return this._defaultMaterial;
    }
}
exports.default = DefaultMaterial;
//# sourceMappingURL=defaultMaterial.js.map